import React, { useState } from "react";
import styled from "styled-components";

import AddSongFlow from "../../../service/add-song-flow";
import PlaylistDetails from "./info";
import ListView from "./list";
import GridView from "./grid";
import Error from "../../views/error";
import { Box, VGap } from "../../../comps";

const Wrap = styled(Box)`
  width: 100%;
  height: 100%;
  position: relative;
`;

const BkgGradient = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  -webkit-filter: blur(50px);
  -moz-filter: blur(50px);
  -o-filter: blur(50px);
  -ms-filter: blur(50px);
  filter: blur(50px);
  opacity: 0.3;
`;

const Content = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 5px;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.color.GRAY_2};
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.color.GRAY_1};
    border-radius: 20px;
  }
`;

const PlaylistViewWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: auto;
`;

const EmptyPlaylist = styled(Box)`
  width: 100%;
  cursor: pointer;
`;

const VIEW_TYPES = {
  MIXED_GRID: 0,
  TABLE: 1,
  LIST: 4,
  FLUID_GRID: 2,
};

export default ({ playlist, refresh, savedSongs }) => {
  const [view, setView] = useState(VIEW_TYPES.LIST);

  const handleAddSong = () => {
    AddSongFlow.initiate({ type: "playlist", id: playlist.id, onAdd: refresh });
  };

  const playlistView =
    playlist.songs && playlist.songs.length > 0 ? (
      view === VIEW_TYPES.LIST ? (
        <ListView
          playlist={playlist}
          savedSongs={savedSongs}
          refresh={refresh}
        />
      ) : (
        <GridView songs={playlist.songs} />
      )
    ) : (
      <EmptyPlaylist onClick={handleAddSong}>
        <Error message="This playlist doesn't have any song. Add some! " />
      </EmptyPlaylist>
    );

  return (
    <Wrap>
      <BkgGradient src={playlist.thumbnail} />
      <Content>
        <VGap height="10px" />
        <PlaylistDetails
          currentView={view}
          VIEW_TYPES={VIEW_TYPES}
          setView={setView}
          playlist={playlist}
          handleAddSong={handleAddSong}
          refresh={refresh}
        />
        <VGap height="30px" />
        <PlaylistViewWrapper>{playlistView}</PlaylistViewWrapper>
      </Content>
    </Wrap>
  );
};
